import { Cookies } from 'react-cookie';
import APIService from '../../services/api';
import { handleError } from '../infos/actions';
import {
    NEWS_PENDING,
    NEWS_FAILED,
    NEWS_DOWNLOADED,
    NEWS_RESET,
    ONE_NEWS_RESET,
    ONE_NEWS_FOCUS,
    ONE_NEWS_DOWNLOADED,
    ONE_NEWS_FAILED,
    ONE_NEWS_DELETING,
    ONE_NEWS_DELETED,
    ONE_NEWS_EDITING,
    ONE_NEWS_POSTING,
    ONE_NEWS_MEDIA_FOCUS,
    ONE_NEWS_MEDIA_UPLOADING,
    ONE_NEWS_MEDIA_FAILED,
    ONE_NEWS_MEDIA_UPLOADED,
    ONE_NEWS_MEDIA_DELETING,
    ONE_NEWS_MEDIA_DELETED,
} from './types';

const cookies = new Cookies();

// Action creators

export const newsResetAction = () => {
    return {
        type: NEWS_RESET,
    };
};

export const oneNewsResetAction = () => {
    return {
        type: ONE_NEWS_RESET,
    };
};

export const newsPendingAction = () => {
    return {
        type: NEWS_PENDING,
    };
};

export const postOneNewsAction = () => {
    return {
        type: ONE_NEWS_POSTING,
    };
};

export const oneNewsEditingAction = () => {
    return {
        type: ONE_NEWS_EDITING,
    };
};

export const newsDownloadedAction = (news, lang) => {
    return {
        type: NEWS_DOWNLOADED,
        payload: {
            lang: lang,
            news: news,
        },
    };
};

export const oneNewsDownloadedAction = (oneNews, lang) => {
    return {
        type: ONE_NEWS_DOWNLOADED,
        payload: {
            lang: lang,
            oneNews: oneNews,
        },
    };
};

export const deleteOneNewsAction = () => {
    return {
        type: ONE_NEWS_DELETING,
    };
};

export const oneNewsDeletedAction = (id, lang) => {
    return {
        type: ONE_NEWS_DELETED,
        payload: {
            id: id,
            lang: lang,
        },
    };
};

export const oneNewsFocusAction = (oneNews, lang) => {
    return {
        type: ONE_NEWS_FOCUS,
        payload: {
            oneNews: oneNews,
            lang: lang,
        },
    };
};

export const oneNewsMediaFocusAction = (media) => {
    return {
        type: ONE_NEWS_MEDIA_FOCUS,
        payload: media,
    };
};

export const uploadMediaAction = (media) => {
    return {
        type: ONE_NEWS_MEDIA_UPLOADING,
        payload: media,
    };
};

export const uploadMediaFailedAction = (media) => {
    return {
        type: ONE_NEWS_MEDIA_FAILED,
        payload: media,
    };
};

export const uploadMediaSucceedAction = (media) => {
    return {
        type: ONE_NEWS_MEDIA_UPLOADED,
        payload: media,
    };
};

export const deleteMediaAction = () => {
    return {
        type: ONE_NEWS_MEDIA_DELETING,
    };
};

export const oneNewsMediaDeletedAction = (mediaId) => {
    return {
        type: ONE_NEWS_MEDIA_DELETED,
        payload: mediaId,
    };
};

// Actions

export function resetNews() {
    return function (dispatch) {
        dispatch(newsResetAction());
    };
}

export function resetOneNews() {
    return function (dispatch) {
        dispatch(oneNewsResetAction());
    };
}

export function getNews(app, lang) {
    return function (dispatch) {
        dispatch(newsPendingAction());
        return APIService
            .getNews(app, cookies.get('token'), lang)
            .then(news => {
                dispatch(newsDownloadedAction(news, lang));
            })
            .catch((error) => {
                dispatch(handleError(error, NEWS_FAILED));
            });
    };
}

export function fetchOneNews(appId, oneNewsId, lang) {
    return function (dispatch, getState) {
        let news = getState().news.content[lang];
        if (news !== undefined) {
            let oneNews = news.find(function (oneNews) {
                return oneNews.id === oneNewsId;
            });
            if (oneNews !== undefined && oneNews) {
                return dispatch(oneNewsFocusAction(oneNews, lang));
            }
        }
        return dispatch(getOneNews(appId, oneNewsId, lang));
    };
}

export function getOneNews(appId, oneNewsId, lang) {
    return function (dispatch) {
        dispatch(newsPendingAction());
        return APIService
            .getOneNews(appId, oneNewsId, cookies.get('token'), lang)
            .then(oneNews => {
                dispatch(oneNewsDownloadedAction(oneNews, lang));
            })
            .catch((error) => {
                dispatch(handleError(error, ONE_NEWS_FAILED));
            });
    };
}

export function deleteOneNews(appId, oneNewsId, lang) {
    return function (dispatch) {
        dispatch(deleteOneNewsAction());
        return APIService
            .deleteOneNews(appId, oneNewsId, cookies.get('token'), lang)
            .then(() => {
                dispatch(oneNewsDeletedAction(oneNewsId, lang));
            })
            .catch((error) => {
                dispatch(handleError(error, ONE_NEWS_FAILED));
            });
    };
}

export function putOneNews(appId, oneNews, lang) {
    return function (dispatch) {
        dispatch(oneNewsEditingAction());
        return APIService
            .putOneNews(appId, oneNews, cookies.get('token'), lang)
            .then(oneNews => {
                dispatch(oneNewsDownloadedAction(oneNews, lang));
            })
            .catch((error) => {
                dispatch(handleError(error, ONE_NEWS_FAILED));
            });
    };
}

export function postOneNews(appId, oneNews, lang) {
    return function (dispatch) {
        dispatch(postOneNewsAction());
        return APIService
            .postOneNews(appId, oneNews, cookies.get('token'), lang)
            .then(oneNews => {
                dispatch(oneNewsDownloadedAction(oneNews, lang));
            })
            .catch((error) => {
                dispatch(handleError(error, ONE_NEWS_FAILED));
            });
    };
}

// MEDIA

export function fetchOneNewsMedia(appId, oneNewsId, mediaId, lang) {
    return function (dispatch, getState) {
        return dispatch(getOneNewsMedia(appId, oneNewsId, mediaId, lang));
    };
}

export function getOneNewsMedia(appId, oneNewsId, mediaId, lang) {
    return function (dispatch) {
        dispatch(newsPendingAction());
        return APIService
            .getOneNewsMedia(appId, oneNewsId, mediaId, cookies.get('token'), lang)
            .then(media => {
                dispatch(oneNewsMediaFocusAction(media));
            })
            .catch((error) => {
                dispatch(handleError(error, NEWS_FAILED));
            });
    };
}

export function deleteOneNewsMedia(appId, oneNewsId, media, lang) {
    return function (dispatch) {
        dispatch(deleteMediaAction());
        return APIService
            .deleteOneNewsMedia(appId, oneNewsId, media, cookies.get('token'), lang)
            .then(() => {
                dispatch(oneNewsMediaDeletedAction(media.id));
            })
            .catch((error) => {
                dispatch(handleError(error, ONE_NEWS_FAILED));
            });
    };
}

export function postOneNewsMedia(appId, oneNewsId, media, lang, onUploadProgress = null) {
    return function (dispatch) {
        dispatch(uploadMediaAction(media));
        if (typeof media === 'string') {
            return APIService
                .postOneNewsLinkMedia(
                    appId,
                    oneNewsId,
                    media,
                    cookies.get('token'),
                    lang,
                )
                .then(oneNews => {
                    dispatch(oneNewsDownloadedAction(oneNews, lang));
                    dispatch(uploadMediaSucceedAction(media));
                })
                .catch((error) => {
                    dispatch(handleError(error));
                    dispatch(uploadMediaFailedAction(media));
                });
        } else {
            return APIService
                .postOneNewsMedia(
                    appId,
                    oneNewsId,
                    media,
                    cookies.get('token'),
                    lang,
                    onUploadProgress,
                )
                .then(oneNews => {
                    dispatch(oneNewsDownloadedAction(oneNews, lang));
                    dispatch(uploadMediaSucceedAction(media));
                })
                .catch((error) => {
                    dispatch(handleError(error));
                    dispatch(uploadMediaFailedAction(media));
                });
        }
    };
}

export function putOneNewsMedia(appId, oneNewsId, media, lang) {
    return function (dispatch) {
        dispatch(uploadMediaAction(media));
        return APIService
            .putOneNewsMedia(appId, oneNewsId, media, cookies.get('token'), lang)
            .then(oneNews => {
                dispatch(oneNewsDownloadedAction(oneNews, lang));
                dispatch(uploadMediaSucceedAction(media));
            })
            .catch((error) => {
                dispatch(handleError(error));
                dispatch(uploadMediaFailedAction(media));
            });
    };
}




// WEBPACK FOOTER //
// src/store/news/actions.js